export const iconFontAwesomeDevicesHardwareEthernet = (
	<i className="fa-solid fa-ethernet"></i>
);
